import React, { useState, useEffect } from 'react';

const Vaping1TemplateWidget = ({ selectedLayout,isTemplateId,widgetId,ageVerificationTabData }) => {
    const [birthMonth, setBirthMonth] = useState('');
    const [birthDay, setBirthDay] = useState('');
    const [birthYear, setBirthYear] = useState('');

    const {
        is_website_frontend,
        verification_method,
        minimum_age,
        action_type,
        action_redirect_url,
        action_message,
        message,
        caption,
        additional_info,
        submit_button_text,
        yes_button_text,
        no_button_text,
        overlay_background_color,
        popup_background_color,
        text_color,
        submit_button_color,
        yes_button_color,
        no_button_color,
        message_font,
        text_font,
        additional_text_font,
    } = ageVerificationTabData || {};

    const [error, setError] = useState('');
    const [showActionMessage, setShowActionMessage] = useState(false);
    const [hideWidget, setHideWidget] = useState(false);

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/age-verification/temp-css/AgeVerificationWidget.css`;
        if (widgetId) {
            link.setAttribute("age-verification-data-dynamic-css", "age-verification");
        } else {
            link.setAttribute("data-dynamic-css", "age-verification");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="age-verification"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    useEffect(() => {
        const isVerified = localStorage.getItem('age_verified');
        if (is_website_frontend === 'website-frontend' && isVerified === 'true') {
            setHideWidget(true);
        }
    }, [is_website_frontend]);

    const handleSubmit = () => {
        // Handle Year of Birth Only
        if (verification_method === 'Year of Birth') {
            if (!birthYear) {
                setError('Please enter your birth year');
                return;
            }
            const finalAge = new Date().getFullYear() - parseInt(birthYear);
            if (finalAge < minimum_age) {
                setShowActionMessage(true);
                setTimeout(() => setShowActionMessage(false), 3000);
            } else {
                localStorage.setItem('age_verified', 'true');
                setError('');
                setShowActionMessage(false);
                setHideWidget(true);
                if (action_type === "Redirect_URL" && action_redirect_url) {
                    window.open(action_redirect_url, '_blank');
                } else if (is_website_frontend !== 'website-frontend') {
                    setTimeout(() => setHideWidget(false), 3000);
                }
            }
            return;
        }

        // Handle Full Date of Birth
        if (!birthMonth || !birthDay || !birthYear) {
            setError('Please enter complete birth date');
            return;
        }

        const birthdate = `${birthYear}-${birthMonth.padStart(2, '0')}-${birthDay.padStart(2, '0')}`;
        const birthDateObj = new Date(birthdate);
        const today = new Date();

        let age = today.getFullYear() - birthDateObj.getFullYear();
        const hasHadBirthdayThisYear =
            today.getMonth() > birthDateObj.getMonth() ||
            (today.getMonth() === birthDateObj.getMonth() && today.getDate() >= birthDateObj.getDate());

        if (!hasHadBirthdayThisYear) age--;

        if (age < minimum_age) {
            setShowActionMessage(true);
            setError('');
            setTimeout(() => setShowActionMessage(false), 3000);
        } else {
            localStorage.setItem('age_verified', 'true');
            setError('');
            setShowActionMessage(false);
            setHideWidget(true);
            if (action_type === "Redirect_URL" && action_redirect_url) {
                window.open(action_redirect_url, '_blank');
            } else if (is_website_frontend !== 'website-frontend') {
                setTimeout(() => setHideWidget(false), 3000);
            }
        }
    };

    const handleYesNoSubmit = (isOldEnough) => {
        if (!isOldEnough) {
            setShowActionMessage(true);
            setTimeout(() => setShowActionMessage(false), 3000);
            return;
        }

        localStorage.setItem('age_verified', 'true');
        setError('');
        setShowActionMessage(false);
        setHideWidget(true);

        if (action_type === "Redirect_URL" && action_redirect_url) {
            window.open(action_redirect_url, '_blank');
        } else if (is_website_frontend !== 'website-frontend') {
            setTimeout(() => setHideWidget(false), 3000);
        }
    };

    if (hideWidget) return null;

    const getContrastColor = (bgColor) => {
        const color = bgColor.replace('#', '');
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5 ? '#000' : '#fff';
    };

    return (
        <>
            <div className={`upgadeify age-verification-vaping-1-temp ${is_website_frontend}`}>
                <div className={`upgadeify age_verification_popupmain age-verification-marijuana-temp ${is_website_frontend}`} style={{ backgroundColor: overlay_background_color }}>
                        <div className="age_verification_popup"
                            style={{background: popup_background_color ,borderRadius: "12px",paddingBlock: "40px"}}>

                            {showActionMessage && (
                                <p className='action_message' style={{ color: text_color }}>{action_message}</p>
                            )}

                            <h1 style={{ color: text_color, fontSize: message_font,marginBottom:"10px" }}>{message}</h1>
                            <p style={{ color: text_color, fontSize: text_font }}>{caption}</p>

                            {verification_method === 'Date of Birth' && (
                            <>
                                <div className='age_verification_whisky_btn_dob'>
                                    <input className="ageverified_input" type="number" placeholder="MM" min="1" max="12" value={birthMonth} onChange={(e) => setBirthMonth(e.target.value)} style={{ width: "60px", color: text_color, fontSize: text_font,background: "transparent" }} />
                                    <input className="ageverified_input" type="number" placeholder="DD" min="1" max="31" value={birthDay} onChange={(e) => setBirthDay(e.target.value)} style={{ width: "60px", color: text_color, fontSize: text_font,background: "transparent" }} />
                                    <input className="ageverified_input" type="number" placeholder="YYYY" min="1900" max={new Date().getFullYear()} value={birthYear} onChange={(e) => setBirthYear(e.target.value)} style={{ width: "80px", color: text_color, fontSize: text_font,background: "transparent" }} />
                                </div>
                                <div className='age_verification_whisky_btn'>
                                    <button className='btn' style={{ marginTop: "10px", backgroundColor: submit_button_color, color: getContrastColor(submit_button_color), fontSize: text_font }} onClick={handleSubmit}>{submit_button_text}</button>
                                    {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                                </div>
                            </>
                            )}

                            {verification_method === 'Yes/No Buttons' && (
                                <div className='age_verification_whisky_btn_yes_no_button'>
                                    <button className='btn' style={{ backgroundColor: yes_button_color, color: getContrastColor(yes_button_color), fontSize: text_font, marginRight: '10px' }} onClick={() => handleYesNoSubmit(true)}>{yes_button_text}</button>
                                    <button className='btn' style={{ backgroundColor: no_button_color, color: getContrastColor(no_button_color), fontSize: text_font }} onClick={() => handleYesNoSubmit(false)}>{no_button_text}</button>
                                </div>
                            )}

                            {verification_method === 'Year of Birth' && (
                                <div className='age_verification_whisky_btn'>
                                    <input type="number" placeholder="YYYY" min="1900" max={new Date().getFullYear()} value={birthYear} onChange={(e) => setBirthYear(e.target.value)} style={{ width: "100px", background: "linear-gradient(131deg, #fff -4.12%, #fff 100%)", color: text_color, fontSize: text_font }} />
                                    <button className='btn' style={{ backgroundColor: submit_button_color, color: getContrastColor(submit_button_color), fontSize: text_font,}} onClick={handleSubmit}>{submit_button_text}</button>
                                    {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                                </div>
                            )}

                            <p className='sm_text' style={{ color: text_color, fontSize: additional_text_font,marginTop: "20px" }}>{additional_info}</p>
                        </div>
                    </div>
            </div>
        </>
    );
};

export default Vaping1TemplateWidget;
